exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lessMargin-73452c9f{margin:0 0 20px 0}.successMessage-9c867990{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"lessMargin": "lessMargin-73452c9f",
	"successMessage": "successMessage-9c867990"
};